import type React from "react"

import type { AppTextProps } from "./Text"

import { AppText } from "./Text"
import { COLORS } from "./theme"
/**
 * A form error message
 */
export function FormError({
  children,
  ...rest
}: AppTextProps): React.JSX.Element | null {
  if (Boolean(children)) {
    return (
      <AppText color={COLORS.$invalid} id={"formError"} {...rest}>
        {children}
      </AppText>
    )
  }
  return null
}
